import { Component, Input, Output, EventEmitter, AfterViewChecked, OnInit } from '@angular/core';
import { Equipment, Document } from '@/interfaces/requirement';
import { RequirementService } from '@/services/requirement/requirement.service';
import { Person } from '@/interfaces/person';
import { BoxColors } from '../person-card/person-card.component';
import { PersonService } from '@/services/person/person.service';
import { FormArray } from '@angular/forms';
import { alLeastOneDateEndMustBeNotUndefined } from './license-details.validators';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { normalize } from '@/utils/normalizeString';

@Component({
  selector: 'app-license-detail',
  templateUrl: './license-detail.component.html',
  styleUrls: ['./license-detail.component.css'],
})
export class LicenseDetailComponent implements OnInit, AfterViewChecked {

  @Input() requirementId?: number = 0;
  @Input() personId: number = 0;
  @Input() personRutDv?: string;

  @Input() assetId: number = 0;
  @Input() shouldShowDocumentLinks: boolean = false;
  @Input() shouldShowPersonalData: boolean = false;
  @Input() personalDataTitle: string = 'Información personal';
  @Input() equipmentTitle: string = 'Detalle de la solicitud';
  @Input() shouldShowEquipmentTitle: boolean = true;

  @Input() shouldShowFlow: boolean = true;
  @Input() shouldShowRequestNumberTitle: boolean = true;
  @Output() goBack = new EventEmitter<boolean>();

  @Input() gettingDataRequirement: boolean = false;
  @Input() gettingDataPerson: boolean = false;
  @Input() getDetailsError: boolean = false;
  @Input() getPersonError: boolean = false;

  @Input() set personData(person: Partial<Person>) {
    this._personData = person;
    this.personMdmid = person.mdmid;
  }
  get personData(): Partial<Person> {
    return this._personData;
  }
  _personData: Partial<Person> = {}

  @Input() equipments: Equipment[] = [];
  @Input() documents: Document[] = [];
  @Input() shouldEditEffectiveDate: boolean = false;
  @Input() documentTableForm = new FormArray([]);

  @Input() mineDocumentTableForm: FormArray = new FormArray([]);
  @Input() mineDocuments?: Document[];

  @Input() shouldShowMineDocumentTable = false;

  @Input() licenseId?: number = 0;
  @Input() licenseNumber?: string = '';
  @Input() shouldShowLicenseSection?: boolean = false;
  @Input() backButtonText: string = '';
  @Input() restrictions?: string;
  @Input() realMunicipalLicenses: string[] = [];

  personCardBoxColor: BoxColors = BoxColors.WHITE;

  driverIsEmployee: boolean = false;
  personMdmid?: string;

  flowDataIsLoaded: boolean = false;
  gettingLicenseData: boolean = false;
  getLicenseDataError: boolean = false;

  qrImage: SafeUrl = '';

  constructor(
    private requirementService: RequirementService,
    private domSanitizer: DomSanitizer,
    private personService: PersonService,
  ) {
  }

  getPersonObserver = (res: Person) => {
    this.personData = res;
    this.gettingDataPerson = false;
    this.getPersonError = false;
    this.driverIsEmployee = normalize(res?.entity) === normalize('Employee');
  }

  ngOnInit() {
    if (!this.personMdmid && this.personRutDv) this.personMdmid = this.personRutDv;
    this.documentTableForm.setValidators(alLeastOneDateEndMustBeNotUndefined(this.documents));
    if (this.licenseId && this.shouldShowLicenseSection) {
      if (!this.qrImage) {
        this.requirementService.getLicenseQr(this.licenseId).subscribe({
          next: async (imageBlob) => {
            const objectURL = URL.createObjectURL(imageBlob);
            this.qrImage = this.domSanitizer.bypassSecurityTrustUrl(objectURL);
          },
        });
      }
    }
  }
  ngAfterViewChecked() {
    if (this.requirementId && this.equipments.length === 0 && !this.gettingDataRequirement && !this.getDetailsError) {
      this.gettingDataRequirement = true;
      if (this.requirementId) {
        this.requirementService.getDetails(this.requirementId).subscribe({
          next: (data) => {
            this.assetId = data.assetId;
            this.gettingDataRequirement = false;
            this.equipments = data.equipments;
            this.documents = data.documents;
            if (this.shouldShowPersonalData && !this.personId) {
              this.personService.getPersonDataByMdmid(data.driverMdmid).subscribe({
                next: this.getPersonObserver,
              });
            }
          },
          error: () => {
            this.gettingDataRequirement = false;
            this.equipments = [];
            this.documents = [];
            this.getDetailsError = true;
          },
        });
      }
    }
    if (this.personId && Object.keys(this.personData).length === 0 && !this.gettingDataPerson && !this.getPersonError && this.shouldShowPersonalData) {
      this.gettingDataPerson = true;
      const personData$ = this.personService.getPersonDataById(this.personId);
      personData$.subscribe({
        next: this.getPersonObserver,
      });
    }
    if (this.personRutDv && Object.keys(this.personData).length === 0 && !this.gettingDataPerson && !this.getPersonError && this.shouldShowPersonalData) {
      this.gettingDataPerson = true;
      const personData$ = this.personService.getPersonDataByMdmid(this.personRutDv);
      personData$.subscribe({
        next: this.getPersonObserver,
      });
    }
  }

  onBack() {
    this.goBack.emit();
  }
}
